_ = require('lodash')
$ = require('jquery')

GroupSearchCtrl = ($scope ,$location ,$filter ,$routeParams ,groupRegisDataService ,userInfo ,$ngConfirm) ->
  #default Value
  angular.element(document.body).css 'min-width', 0
  pageSize = 4
  $scope.groups = []
  $scope.currentPage = 0
  $scope.isLoading = true
  $scope.noResults = false
  $scope.keyword   = $routeParams.key ? ''

  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    groupRegisDataService.searchGroup($scope.keyword ,$scope.currentPage , pageSize )
      .then (data) ->
        $scope.groups = _.union($scope.groups , data.groups)
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.groups.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage isnt $scope.totalPages

  $scope.searchGroup = (keyTemp)->
    $scope.keyword   = keyTemp
    $scope.groups = []
    $scope.currentPage = 0
    $scope.isLoading = true
    $scope.noResults = false
    $scope.loadMore()

  $scope.goCreatePage = ->
    $location.path('/groups/registration')

  $scope.backJoinList = ->
    $location.path('/groups')

  $scope.gotoGroup = (id) ->
    groupRegisDataService.setTempData(createCacheData())
    $location.url('/groups/'+id)

  $scope.requestGroup = (group)->
    userId = userInfo.user_id
    groupId = group.id
    if userId == '' || groupId == ''
      return
    params =
      user_id : userId
      group_id : groupId
    groupRegisDataService.joinGroup(params).finally ->
      group.user_status = 'pending'
      mess = $filter('translate')('_GROUP.TOOLBAR.REQUEST_MESS_JOIN_GROUP')
      $ngConfirm(mess)

  $scope.$watch('groups' , () ->
    if $scope.currentPage <= 1 || $scope.fromCached
      $scope.fromCached = false
      return
    $("html, body").animate({ scrollTop:$(document).height()}, "slow")
  , false)

  createCacheData = ->
    cacheData =
      groups: $scope.groups
      currentPage: $scope.currentPage
      isLoading: $scope.isLoading
      noResults: $scope.noResults
      keyword: $scope.keyword
      totalPages: $scope.totalPages
    cacheData

  setDataFromCache = (data) ->
    $scope.keyword = data.keyword
    $scope.groups = data.groups
    $scope.currentPage = data.currentPage
    $scope.isLoading = data.isLoading
    $scope.noResults = data.noResults
    $scope.totalPages = data.totalPages
    $scope.fromCached = true

  cachedData = groupRegisDataService.getTempData()
  if cachedData
    groupRegisDataService.setTempData(null)
    setDataFromCache(cachedData)
    return

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
  )

  $scope.loadMore()

GroupSearchCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  '$routeParams'
  'groupRegisDataService'
  'userInfo'
  '$ngConfirm'
]

module.exports = GroupSearchCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-search-controller.coffee